// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file cos/interrupt.proto (package lvdr.v2.cos, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cos/interrupt.proto.
 */
export const file_cos_interrupt: GenFile = /*@__PURE__*/
  fileDesc("ChNjb3MvaW50ZXJydXB0LnByb3RvEgtsdmRyLnYyLmNvcyJWChBJbnRlcnJ1cHRpb25JdGVtEgoKAmlkGAEgASgJEgwKBGtpbmQYAiABKAkSCwoDcmVmGAMgASgJEg0KBXRpdGxlGAQgASgJEgwKBGxpbmsYBSABKAki/wEKEUludGVycnVwdGlvbkV2ZW50EgoKAmlkGAEgASgJEgwKBGtpbmQYAiABKAkSCwoDcmVmGAMgASgJEg0KBWxldmVsGAQgASgJEg4KBnJlYXNvbhgFIAEoCRINCgV0aXRsZRgGIAEoCRIMCgRsaW5rGAcgASgJEhMKC2J1ZGdldF91c2VkGAggASgFEhQKDGJ1ZGdldF9saW1pdBgJIAEoBRIWCg5yZWxlYXNlZF9jb3VudBgKIAEoBRIvCghyZWxlYXNlZBgLIAMoCzIdLmx2ZHIudjIuY29zLkludGVycnVwdGlvbkl0ZW0SEwoLcmVhc29uX2NvZGUYDCABKAkiNAoWSW50ZXJydXB0aW9uQWN0UmVxdWVzdBIKCgJpZBgBIAEoCRIOCgZhY3Rpb24YAiABKAkiWAoXSW50ZXJydXB0aW9uQWN0UmVzcG9uc2USCgoCb2sYASABKAgSMQoNc25vb3plZF91bnRpbBgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiKwoQU2V0VGVsbE1lUmVxdWVzdBILCgNyZWYYASABKAkSCgoCb24YAiABKAgiOwoRU2V0VGVsbE1lUmVzcG9uc2USCgoCb24YASABKAgSDQoFY291bnQYAiABKAUSCwoDbWF4GAMgASgFIlgKClRlbGxNZU1hcmsSCwoDcmVmGAEgASgJEi4KCmNyZWF0ZWRfYXQYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEg0KBXRpdGxlGAMgASgJIhMKEUxpc3RUZWxsTWVSZXF1ZXN0IlgKEkxpc3RUZWxsTWVSZXNwb25zZRImCgVtYXJrcxgBIAMoCzIXLmx2ZHIudjIuY29zLlRlbGxNZU1hcmsSDQoFY291bnQYAiABKAUSCwoDbWF4GAMgASgFIvABChJJbnRlcnJ1cHRpb25SZWNvcmQSCgoCaWQYASABKAkSDAoEa2luZBgCIAEoCRILCgNyZWYYAyABKAkSDQoFbGV2ZWwYBCABKAkSDwoHb3V0Y29tZRgFIAEoCRIOCgZyZWFzb24YBiABKAkSLgoKZGVjaWRlZF9hdBgHIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASDgoGb3BlbmVkGAggASgIEhEKCWRpc21pc3NlZBgJIAEoCBINCgV0aXRsZRgKIAEoCRIMCgRsaW5rGAsgASgJEhMKC3JlYXNvbl9jb2RlGAwgASgJIiAKHkxpc3RSZWNlbnRJbnRlcnJ1cHRpb25zUmVxdWVzdCJRCh9MaXN0UmVjZW50SW50ZXJydXB0aW9uc1Jlc3BvbnNlEi4KBWl0ZW1zGAEgAygLMh8ubHZkci52Mi5jb3MuSW50ZXJydXB0aW9uUmVjb3JkIhsKGUdldEludGVycnVwdEJ1ZGdldFJlcXVlc3QibwoaR2V0SW50ZXJydXB0QnVkZ2V0UmVzcG9uc2USDAoEdXNlZBgBIAEoBRINCgVsaW1pdBgCIAEoBRILCgNtYXgYAyABKAUSFgoOc25vb3plX3NlY29uZHMYBCABKAUSDwoHZW5hYmxlZBgFIAEoCEIkWiJnaXRodWIuY29tL2d2czQyL2x2ZHIvcHJvdG8vdjIvY29zYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * One released item inside a release card.
 *
 * @generated from message lvdr.v2.cos.InterruptionItem
 */
export type InterruptionItem = Message<"lvdr.v2.cos.InterruptionItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: string ref = 3;
   */
  ref: string;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: string link = 5;
   */
  link: string;
};

/**
 * Describes the message lvdr.v2.cos.InterruptionItem.
 * Use `create(InterruptionItemSchema)` to create a new message.
 */
export const InterruptionItemSchema: GenMessage<InterruptionItem> = /*@__PURE__*/
  messageDesc(file_cos_interrupt, 0);

/**
 * Pushed on interrupt, by intake or by a release. `title` is in memory only
 * (D12) and may be empty, in which case the web resolves it. `reason` is the
 * display sentence interrupt.CardReason(kind, code, used, limit) and the web
 * renders it verbatim; `reason_code` is the code.
 *
 * For an intake interrupt, `id` is the row id, `released_count` is 0 and
 * `released` is empty. For a release, `id` is the newest released row's id,
 * `released_count == len(released)`, and `released` carries every released
 * row, newest first; the top-level kind, ref, title and link repeat the
 * newest item.
 *
 * @generated from message lvdr.v2.cos.InterruptionEvent
 */
export type InterruptionEvent = Message<"lvdr.v2.cos.InterruptionEvent"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: string ref = 3;
   */
  ref: string;

  /**
   * @generated from field: string level = 4;
   */
  level: string;

  /**
   * @generated from field: string reason = 5;
   */
  reason: string;

  /**
   * @generated from field: string title = 6;
   */
  title: string;

  /**
   * @generated from field: string link = 7;
   */
  link: string;

  /**
   * @generated from field: int32 budget_used = 8;
   */
  budgetUsed: number;

  /**
   * @generated from field: int32 budget_limit = 9;
   */
  budgetLimit: number;

  /**
   * @generated from field: int32 released_count = 10;
   */
  releasedCount: number;

  /**
   * @generated from field: repeated lvdr.v2.cos.InterruptionItem released = 11;
   */
  released: InterruptionItem[];

  /**
   * @generated from field: string reason_code = 12;
   */
  reasonCode: string;
};

/**
 * Describes the message lvdr.v2.cos.InterruptionEvent.
 * Use `create(InterruptionEventSchema)` to create a new message.
 */
export const InterruptionEventSchema: GenMessage<InterruptionEvent> = /*@__PURE__*/
  messageDesc(file_cos_interrupt, 1);

/**
 * action: open | snooze | dismiss
 *
 * @generated from message lvdr.v2.cos.InterruptionActRequest
 */
export type InterruptionActRequest = Message<"lvdr.v2.cos.InterruptionActRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string action = 2;
   */
  action: string;
};

/**
 * Describes the message lvdr.v2.cos.InterruptionActRequest.
 * Use `create(InterruptionActRequestSchema)` to create a new message.
 */
export const InterruptionActRequestSchema: GenMessage<InterruptionActRequest> = /*@__PURE__*/
  messageDesc(file_cos_interrupt, 2);

/**
 * @generated from message lvdr.v2.cos.InterruptionActResponse
 */
export type InterruptionActResponse = Message<"lvdr.v2.cos.InterruptionActResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * set for snooze
   *
   * @generated from field: google.protobuf.Timestamp snoozed_until = 2;
   */
  snoozedUntil?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.cos.InterruptionActResponse.
 * Use `create(InterruptionActResponseSchema)` to create a new message.
 */
export const InterruptionActResponseSchema: GenMessage<InterruptionActResponse> = /*@__PURE__*/
  messageDesc(file_cos_interrupt, 3);

/**
 * ref: research:<id> | workflow_run:<id> | workflow:<id> | mail:<conversation>
 *
 * @generated from message lvdr.v2.cos.SetTellMeRequest
 */
export type SetTellMeRequest = Message<"lvdr.v2.cos.SetTellMeRequest"> & {
  /**
   * @generated from field: string ref = 1;
   */
  ref: string;

  /**
   * @generated from field: bool on = 2;
   */
  on: boolean;
};

/**
 * Describes the message lvdr.v2.cos.SetTellMeRequest.
 * Use `create(SetTellMeRequestSchema)` to create a new message.
 */
export const SetTellMeRequestSchema: GenMessage<SetTellMeRequest> = /*@__PURE__*/
  messageDesc(file_cos_interrupt, 4);

/**
 * @generated from message lvdr.v2.cos.SetTellMeResponse
 */
export type SetTellMeResponse = Message<"lvdr.v2.cos.SetTellMeResponse"> & {
  /**
   * @generated from field: bool on = 1;
   */
  on: boolean;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;

  /**
   * @generated from field: int32 max = 3;
   */
  max: number;
};

/**
 * Describes the message lvdr.v2.cos.SetTellMeResponse.
 * Use `create(SetTellMeResponseSchema)` to create a new message.
 */
export const SetTellMeResponseSchema: GenMessage<SetTellMeResponse> = /*@__PURE__*/
  messageDesc(file_cos_interrupt, 5);

/**
 * @generated from message lvdr.v2.cos.TellMeMark
 */
export type TellMeMark = Message<"lvdr.v2.cos.TellMeMark"> & {
  /**
   * @generated from field: string ref = 1;
   */
  ref: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp | undefined;

  /**
   * resolved per request, never stored
   *
   * @generated from field: string title = 3;
   */
  title: string;
};

/**
 * Describes the message lvdr.v2.cos.TellMeMark.
 * Use `create(TellMeMarkSchema)` to create a new message.
 */
export const TellMeMarkSchema: GenMessage<TellMeMark> = /*@__PURE__*/
  messageDesc(file_cos_interrupt, 6);

/**
 * @generated from message lvdr.v2.cos.ListTellMeRequest
 */
export type ListTellMeRequest = Message<"lvdr.v2.cos.ListTellMeRequest"> & {
};

/**
 * Describes the message lvdr.v2.cos.ListTellMeRequest.
 * Use `create(ListTellMeRequestSchema)` to create a new message.
 */
export const ListTellMeRequestSchema: GenMessage<ListTellMeRequest> = /*@__PURE__*/
  messageDesc(file_cos_interrupt, 7);

/**
 * @generated from message lvdr.v2.cos.ListTellMeResponse
 */
export type ListTellMeResponse = Message<"lvdr.v2.cos.ListTellMeResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.cos.TellMeMark marks = 1;
   */
  marks: TellMeMark[];

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;

  /**
   * @generated from field: int32 max = 3;
   */
  max: number;
};

/**
 * Describes the message lvdr.v2.cos.ListTellMeResponse.
 * Use `create(ListTellMeResponseSchema)` to create a new message.
 */
export const ListTellMeResponseSchema: GenMessage<ListTellMeResponse> = /*@__PURE__*/
  messageDesc(file_cos_interrupt, 8);

/**
 * `reason` is the display sentence (interrupt.ReasonText); `reason_code` the code.
 *
 * @generated from message lvdr.v2.cos.InterruptionRecord
 */
export type InterruptionRecord = Message<"lvdr.v2.cos.InterruptionRecord"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: string ref = 3;
   */
  ref: string;

  /**
   * @generated from field: string level = 4;
   */
  level: string;

  /**
   * @generated from field: string outcome = 5;
   */
  outcome: string;

  /**
   * @generated from field: string reason = 6;
   */
  reason: string;

  /**
   * @generated from field: google.protobuf.Timestamp decided_at = 7;
   */
  decidedAt?: Timestamp | undefined;

  /**
   * @generated from field: bool opened = 8;
   */
  opened: boolean;

  /**
   * @generated from field: bool dismissed = 9;
   */
  dismissed: boolean;

  /**
   * @generated from field: string title = 10;
   */
  title: string;

  /**
   * @generated from field: string link = 11;
   */
  link: string;

  /**
   * @generated from field: string reason_code = 12;
   */
  reasonCode: string;
};

/**
 * Describes the message lvdr.v2.cos.InterruptionRecord.
 * Use `create(InterruptionRecordSchema)` to create a new message.
 */
export const InterruptionRecordSchema: GenMessage<InterruptionRecord> = /*@__PURE__*/
  messageDesc(file_cos_interrupt, 9);

/**
 * @generated from message lvdr.v2.cos.ListRecentInterruptionsRequest
 */
export type ListRecentInterruptionsRequest = Message<"lvdr.v2.cos.ListRecentInterruptionsRequest"> & {
};

/**
 * Describes the message lvdr.v2.cos.ListRecentInterruptionsRequest.
 * Use `create(ListRecentInterruptionsRequestSchema)` to create a new message.
 */
export const ListRecentInterruptionsRequestSchema: GenMessage<ListRecentInterruptionsRequest> = /*@__PURE__*/
  messageDesc(file_cos_interrupt, 10);

/**
 * @generated from message lvdr.v2.cos.ListRecentInterruptionsResponse
 */
export type ListRecentInterruptionsResponse = Message<"lvdr.v2.cos.ListRecentInterruptionsResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.cos.InterruptionRecord items = 1;
   */
  items: InterruptionRecord[];
};

/**
 * Describes the message lvdr.v2.cos.ListRecentInterruptionsResponse.
 * Use `create(ListRecentInterruptionsResponseSchema)` to create a new message.
 */
export const ListRecentInterruptionsResponseSchema: GenMessage<ListRecentInterruptionsResponse> = /*@__PURE__*/
  messageDesc(file_cos_interrupt, 11);

/**
 * @generated from message lvdr.v2.cos.GetInterruptBudgetRequest
 */
export type GetInterruptBudgetRequest = Message<"lvdr.v2.cos.GetInterruptBudgetRequest"> & {
};

/**
 * Describes the message lvdr.v2.cos.GetInterruptBudgetRequest.
 * Use `create(GetInterruptBudgetRequestSchema)` to create a new message.
 */
export const GetInterruptBudgetRequestSchema: GenMessage<GetInterruptBudgetRequest> = /*@__PURE__*/
  messageDesc(file_cos_interrupt, 12);

/**
 * @generated from message lvdr.v2.cos.GetInterruptBudgetResponse
 */
export type GetInterruptBudgetResponse = Message<"lvdr.v2.cos.GetInterruptBudgetResponse"> & {
  /**
   * @generated from field: int32 used = 1;
   */
  used: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: int32 max = 3;
   */
  max: number;

  /**
   * @generated from field: int32 snooze_seconds = 4;
   */
  snoozeSeconds: number;

  /**
   * @generated from field: bool enabled = 5;
   */
  enabled: boolean;
};

/**
 * Describes the message lvdr.v2.cos.GetInterruptBudgetResponse.
 * Use `create(GetInterruptBudgetResponseSchema)` to create a new message.
 */
export const GetInterruptBudgetResponseSchema: GenMessage<GetInterruptBudgetResponse> = /*@__PURE__*/
  messageDesc(file_cos_interrupt, 13);

